<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Supplier</h2>

      <br />

      <div class="form-wrapper">
        <form @submit.prevent="save">
          <div class="form-group">
            <label>Nama Supplier</label>
            <input type="text" v-model="data.nama" />
          </div>
          <div class="form-group">
            <label>No Telp</label>
            <input type="text" v-model="data.no_telp" />
          </div>
          <div class="form-group">
            <label>Alamat</label>
            <textarea v-model="data.alamat"></textarea>
          </div>
          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loadingButton">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
export default {
  name: "SupplierForm",
  components: {},
  data() {
    return {
      loading: false,
      loadingButton: false,
      data: {},
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      api
        .get(
          "/v4/supplier?id=" +
            this.$route.params.id +
            "&id_toko=" +
            this.$toko.id
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    save() {
      if (!this.data.nama) {
        this.$toast("Nama supplier harus diisi ya");
        return;
      }

      this.loadingButton = true;

      this.data.id = this.$route.params.id;
      if (this.data.id < 0) {
        this.data.id = null;
      }

      this.data.id_toko = this.$toko.id;
      api
        .post("/v4/supplier/save", this.data)
        .then((r) => {
          this.loadingButton = false;

          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast("Gagal menyimpan data");
          }
        })
        .catch((e) => {
          this.loadingButton = false;
          this.$toast("Gagal menyimpan data");
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.loadData();
    }
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/master/SupplierForm.vue